<template>
  <div :class="['gallery-container', (currentSlide%2==0 ? 'green' : 'orange' )]">
    <b-container>
      <b-row>
        <b-col>

          <div class="slide-counter">
            <div class="line"></div>
            <div
              v-if="currentSlide == 0"
              class="current"
              :style="'transform: translateX(0%);'"
            />
            <div
              v-else
              class="current"
              :style="'transform: translateX('+((100*(currentSlide+1)) - 100)+'%);'"/>
          </div>

          <div class="btn-arrows">
            <div class="arrow left" @click="goLeft">
              <svg width="42" height="32" viewBox="0 0 42 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path fill-rule="evenodd" clip-rule="evenodd" d="M4.47461 17L18.2241 30.2808L16.8346 31.7193L0.560547 16L16.8346 0.280762L18.2241 1.71928L4.47461 15H41.9999V17H4.47461Z" :fill="currentSlide > 0 ? 'rgba(255,255,255,1)' : 'rgba(255,255,255,.5)'"/>
              </svg>
            </div>
            <div class="arrow right" @click="goRight">
              <svg width="42" height="32" viewBox="0 0 42 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path fill-rule="evenodd" clip-rule="evenodd" d="M37.5254 15L23.7759 1.71924L25.1654 0.280716L41.4395 16L25.1654 31.7192L23.7759 30.2807L37.5254 17L6.48499e-05 17V15L37.5254 15Z" :fill="currentSlide < content.slides.length - 1 ? 'rgba(255,255,255,1)' : 'rgba(255,255,255,.5)'"/>
              </svg>
            </div>
          </div>

          <carousel
            class="slides-container"
            :perPage="1"
            :paginationEnabled="false"
            :navigateTo="this.currentSlide"
            @page-change="changeSlide"
          >
            <slide
              class="slide"
              v-for="(slide, s) in this.content.slides"
              :key="s"
            >
              <div class="title-icon">
                <div class="title" v-html="slide.title"/>
                <div class="icon">
                  <img :src="'./images/icons/'+slide.icon" alt="">
                </div>
              </div>
              <div class="description" v-text="slide.text"></div>
            </slide>
          </carousel>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
export default {
  name: 'Gallery',
  props: ["content"],
  data: function(){
    return {
      currentSlide: 0
    }
  },
  mounted() {
    this.currentSlide = 0
  },
  methods: {
    changeSlide(s){
      this.currentSlide = s
    },
    goLeft(){
      if( this.currentSlide > 0 )
        this.currentSlide --
    },
    goRight(){
      if( this.currentSlide < this.content.slides.length-1 )
        this.currentSlide ++
    }
  }
};
</script>

<!-- Use preprocessors via the lang attribute! e.g. <style lang="scss"> -->
<style lang="scss" scoped>
@import "@/assets/scss/colors.scss";
@import "@/assets/scss/bper-fonts.scss";
.gallery-container{
  min-height: 60vh;
  padding-top: 28px;
  margin-bottom: 40px;
  transition: background 1s;
  .slide-counter{
    position: relative;
    .line{
      position: relative;
      width: 100%;
      height: 1px;
      background-color: rgba($bper-bianco, .5);
    }
    .current{
      position: absolute;
      width: calc(100%/7);
      height: 2px;
      background-color: $bper-bianco;
      transform: translateY(-1.5px);
      transition: transform 1s;
    }
  }
  .btn-arrows{
    position: relative;
    display: flex;
    justify-content: flex-end;
    width: 100%;
    padding-top: 24px;
    padding-bottom: 16px;
    .arrow{
      cursor: pointer;
    }
    .left{
      padding-right: 8px;
    }
    .right{
      padding-left: 8px;
    }
  }
  .slides-container{
    color: $bper-bianco;
    .slide{
      .title-icon{
        display: flex;
        align-items: center;
        margin-bottom: 24px;
        .title{
          @include gallery-title;
        }
        .icon{
          display: none;
        }
      }
      .description{
        @include gallery-description;
        padding-bottom: 32px;
      }
    }
  }
}
.orange{
  background-color: $bper-arancione;
}
.green{
  background-color: $bper-verde-scuro;
}

// -- media query desktop
@media only screen 
  and (min-device-width: 1250px)
  and (orientation: landscape) {
    .gallery-container{
      min-height: 82vh;
      .btn-arrows{
        padding-top: 40px;
        padding-bottom: 40px;
        .arrow{
          cursor: pointer;
        }
        .left{
          padding-right: 8px;
        }
        .right{
          padding-left: 8px;
        }
      }
      .slides-container{
        .slide{
          padding-left: 97px;
          .title-icon{
            display: flex;
            align-items: center;
            margin-bottom: 24px;
            .title{
              @include gallery-title--desktop;
              padding-top: 24px;
            }
            .icon{
              display: block;
              width: 72px;
              height: 72px;
              margin-top: 24px;
              margin-left: 16px;
              img{
                width: 100%;
              }
            }
          }
          .description{
            @include gallery-description--desktop;
            width: 850px;
            padding-top: 24px;
            padding-bottom: 24px;
          }
        }
      }
    }
  }
</style>